import apiClient from "../../utils/api.client";

const getProviders = async (pageNumber, perPage, dispatch, sort) => {
  let url = `/providers-service/supplier?pageNumber=${pageNumber || 1}&pageSize=${perPage || 10}&orderCriteria=${sort?.increasing ? "ASC" : "DESC"}&orderField=${sort?.name || "businessName"}`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getProviders EP: ", error);
    error.epName = "getProviders";
    throw error;
  }
};

const newProvider = async (payload, dispatch) => {
  let url = `/providers-service/supplier`;
  try {
    const response = await apiClient.post(url, payload);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at newProvider EP: ", error);
    throw error;
  }
};

const updateProvider = async (payload, dispatch) => {
  let url = `/providers-service/supplier`;
  try {
    const response = await apiClient.put(url, payload);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at updateProvider EP: ", error);
    throw error;
  }
};

const deleteProvider = async (providerId, dispatch) => {
  let url = `/providers-service/supplier${providerId}`;
  try {
    const response = await apiClient.post(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at deleteProvider EP: ", error);
    throw error;
  }
};

const getGamesProvider = async (providerId, dispatch) => {
  let url = `/providers-service/supplier/${providerId}/gamesids`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getGamesProvider EP: ", error);
    throw error;
  }
};

const addGamesProvider = async (payload, providerId, dispatch) => {
  let url = `/providers-service/supplier/${providerId}/games`;
  try {
    const response = await apiClient.post(url, payload);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at addGamesProvider EP: ", error);
    throw error;
  }
};

const deleteGamesProvider = async (providerId, dispatch) => {
  let url = `/providers-service/supplier/${providerId}/games`;
  try {
    const response = await apiClient.delete(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at deleteGamesProvider EP: ", error);
    throw error;
  }
};

const updateGamesProvider = async (payload, providerId, dispatch) => {
  let url = `/providers-service/supplier/${providerId}/games`;
  try {
    const response = await apiClient.put(url, payload);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at updateGamesProvider EP: ", error);
    throw error;
  }
};

const searchProvider = async (pageNumber, perPage, filters, dispatch) => {
  let url = `/providers-service/supplier/search?pageNumber=${pageNumber}&pageSize=${perPage}&orderCriteria=ASC&orderField=cuit${filters.razonsocial !== "" ? `&razonsocial=${filters.razonsocial}` : ""}${filters.cuit !== 0 ? `&cuit=${filters.cuit.split("-").join("")}` : ""}`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at searchProvider EP: ", error);
    throw error;
  }
};

const getActiveProviders = async () => {
  let url = `/providers-service/supplier?pageNumber=1&pageSize=3&orderCriteria=DESC&orderField=cuit`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getActiveProviders EP: ", error);
    throw error;
  }
};

const getSupplierById = async (id) => {
  let url = `/providers-service/supplier?${id}`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getSupplierById EP: ", error);
    throw error;
  }
};

const providersService = {
  getProviders,
  newProvider,
  updateProvider,
  deleteProvider,
  getGamesProvider,
  addGamesProvider,
  deleteGamesProvider,
  updateGamesProvider,
  searchProvider,
  getActiveProviders,
  getSupplierById,
};

export default providersService;
